module.exports = __webpack_public_path__ + "static/media/earliest.0191918a.jpg";